export default "__VITE_ASSET__eGH7gFo___"